import { Button, Stack, Switch, Typography } from "@mui/material";

type Props = {
	title: string;
	checked?: boolean;
	onChange: () => void;
};
export default function ProductItem({ title, onChange, checked }: Props) {
	return (
		<Stack flexDirection={"row"} alignItems={"center"} sx={{ mt: 1, pb: 1 }} gap={2}>
			<Typography variant='subtitle2'>{title}</Typography>
			<Switch color='primary' size='small' onChange={() => {}} checked={checked} />
			<Button
				onClick={onChange}
				size='small'
				variant={"outlined"}
				color={checked ? "error" : "success"}
			>
				{checked ? "Quitar" : "Agregar"}
			</Button>
		</Stack>
	);
}
